(function () {
    'use strict';

    function ArrayService() {
        var service = {
            toAlphaNumericString: toAlphaNumericString
        };

        return service;

        function toAlphaNumericString(array) {
            const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

            var result = '';

            for (var i = 0; i < array.length; i++) {
                var char = charset.charCodeAt(array[i] % charset.length);
                result += String.fromCharCode(char);
            }

            return result;
        }
    }

    module.exports = ArrayService;
})();